import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Canonical conversion / click status definitions. Edit here once, applies everywhere.
const STATUS_META = {
  APPROVED: {
    tone: "bg-emerald-50 text-emerald-700",
    title: "Approved",
    description:
      "Impact has cleared this conversion. It'll move to Payouts once admin approves the payout date.",
  },
  PENDING: {
    tone: "bg-amber-50 text-amber-700",
    title: "Pending",
    description:
      "Impact is still reviewing this conversion (typically 30–90 days depending on the brand's return window). It may move to APPROVED or REVERSED.",
  },
  REVERSED: {
    tone: "bg-red-50 text-red-700",
    title: "Rejected",
    description:
      "The customer returned, cancelled, or charged back the order. Commission is not payable. This is normal — happens on 5–15% of most brands.",
    label: "REJECTED",
  },
  REJECTED: {
    tone: "bg-red-50 text-red-700",
    title: "Rejected",
    description:
      "The customer returned, cancelled, or charged back the order. Commission is not payable. This is normal — happens on 5–15% of most brands.",
    label: "REJECTED",
  },
  LOCKED: {
    tone: "bg-blue-50 text-blue-700",
    title: "Locked",
    description:
      "Approved and locked in. No further changes possible — will roll into your next payout.",
  },
  click: {
    tone: "bg-slate-100 text-slate-600",
    title: "Click Only",
    description: "Tracked click with no conversion yet.",
  },
  Click: {
    tone: "bg-slate-100 text-slate-600",
    title: "Click Only",
    description: "Tracked click with no conversion yet.",
  },
};

const FALLBACK = {
  tone: "bg-red-50 text-red-700",
  title: "Unknown",
  description: "Non-standard status from Impact. Contact admin if this persists.",
};

export default function StatusPill({ status, size = "sm" }) {
  const meta = STATUS_META[status] || FALLBACK;
  const padding = size === "md" ? "px-2 py-0.5 text-[11px]" : "px-1.5 py-0.5 text-[10px]";
  const label = meta.label || status;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center rounded font-bold tracking-wider cursor-help ${padding} ${meta.tone}`}
            data-testid={`status-pill-${String(status).toLowerCase()}`}
          >
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[260px] text-[12px] leading-snug">
          <div className="font-semibold mb-0.5">{meta.title}</div>
          <div className="text-slate-200">{meta.description}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
